module.exports = __webpack_public_path__ + "img/s03_p01-big.79c4ee55.png";